module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_21.0cf8708d.png";